import { create } from "zustand";
import type { WorkflowDbSchema, WorkflowDbTableData } from "./workflow-db.types";

type WorkflowDbState = {
	data: WorkflowDbTableData;
	schema: WorkflowDbSchema;
	setData: (data: WorkflowDbTableData) => void;
	setSchema: (schema: WorkflowDbSchema) => void;
	clear: () => void;
};

export const useWorkflowDbStore = create<WorkflowDbState>((set) => ({
	data: {},
	schema: { type: "object", properties: [] },
	setData: (data) => set({ data }),
	setSchema: (schema) => set({ schema }),
	clear: () => set({ data: {}, schema: { type: "object", properties: [] } }),
}));
